import React from 'react';
import {
	Create,
	Datagrid,
	Edit,
	EditButton,
	Labeled,
	List,
	ReferenceManyField,
	SimpleForm,
	TextInput,
	TextField, DateField,
	required,
} from 'react-admin';

import {
	WithMasterPermissions,
} from '../DataProviderExtension/authExtension';
import EditInDialogButton from '../components/dialogs/EditInDialogButton';
import {
	CreateTadeUnionNewsForm,
	CreateTradeUnionNewsButton,
	EditTradeUnionNewsForm,
} from './TradeUnionNews';

export const EditTradeUnion = (props) => {
	return (
		<Edit {...props}>
			<SimpleForm>
				<TextInput label="Название" source="shortTitle" />
				<TextInput label="Полное название" source="fullTitle" />
				<Labeled>
					<ReferenceManyField label="Администраторы" reference="TradeUnionAdmin" target="tradeUnion">
						<Datagrid>
							<TextField source="id" />
							<WithMasterPermissions>
								<EditButton />
							</WithMasterPermissions>
						</Datagrid>
					</ReferenceManyField>
				</Labeled>
				<Labeled label="Новости">
					<CreateTradeUnionNewsButton>
						<CreateTadeUnionNewsForm />
					</CreateTradeUnionNewsButton>
				</Labeled>
				<ReferenceManyField reference="TradeUnionNews" target="tradeUnion">
					<Datagrid>
						<TextField source="title" label="Заголовок" />
						<DateField source="displayDate" label="Дата" />
						<EditInDialogButton fullWidth>
							<EditTradeUnionNewsForm />
						</EditInDialogButton>
					</Datagrid>
				</ReferenceManyField>
			</SimpleForm>
		</Edit>
	);
};

export const createTradeUnion = (props) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput label="Название" source="shortTitle" validate={required('Укажите название')} />
				<TextInput label="Полное название" source="fullTitle" />
			</SimpleForm>
		</Create>
	);
};

export const listTradeUnion = (props) => {
	return (
		<List {...props} title="ППО">
			<Datagrid rowClick="edit">
				<TextField label="Название" source="shortTitle" />
				<TextField label="Полное название" source="fullTitle" />
				<EditButton />
			</Datagrid>
		</List>
	);
};
